var React = require('react');

function LocalRoads (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1","data-name":"Layer 1"},[React.createElement("path",{"d":"M14.92,6.61c0,3.54-6.41,11.18-6.41,11.18s-6.4-7.64-6.4-11.18a6.41,6.41,0,0,1,12.81,0Z","key":0}),React.createElement("circle",{"cx":"8.51","cy":"6.61","r":"2.59","fill":"#fff","key":1})]));
}

LocalRoads.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = LocalRoads;

LocalRoads.default = LocalRoads;
